<div class="container-fluid my-2">
  <div class="row">
    <div class="col-md-6">
      <app-cisternas-list></app-cisternas-list>
    </div>
    <div class="col-md-6">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
